import { Box, Flex, useCheckbox, CheckboxProps, Text } from '@chakra-ui/react';

const CustomToggle = (props: CheckboxProps): JSX.Element => {
  const { state, getInputProps, getCheckboxProps } = useCheckbox(props);
  const input = getInputProps();
  const checkbox = getCheckboxProps();
  return (
    <Box as="label">
      <input {...input} />
      <Flex
        {...checkbox}
        cursor="pointer"
        position="relative"
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        height="28px"
        width="56px"
        borderRadius="100px"
        sx={{ transition: 'all 0.2s ease-in-out' }}
        color="custom.levoWhite"
        bg="custom.levoLightGray"
        _checked={{
          justifyContent: 'flex-start',
          bg: 'custom.levoLightYellow',
          color: 'custom.levoLightBlack',
        }}
      >
        <Box
          {...checkbox}
          position="absolute"
          left="-4px"
          width="32px"
          height="32px"
          borderRadius="50%"
          sx={{ transition: 'all 0.2s ease-in-out' }}
          bg="custom.levoDarkGray"
          _checked={{ transform: 'translateX(32px)', bg: 'custom.levoYellow' }}
        />
        <Text textStyle="preTitle" align="center" px="8px">
          {state.isChecked ? 'Yes' : 'No'}
        </Text>
      </Flex>
    </Box>
  );
};

export default CustomToggle;
